import { useApi } from "@/lib/useApi";
import { VideoRow } from "@/components/VideoRow";

export default function Browse({ tag, title }) {
  const { data } = useApi(`/browse?tag=${encodeURIComponent(tag)}`);
  return (
    <div data-testid={`browse-page-${tag.toLowerCase()}`}>
      {data?.rows?.map((row) => (
        <VideoRow
          key={row.id}
          title={row.name}
          videos={row.videos}
          to={tag === "Festival" && row.id !== "all" ? `/festivals/${row.id}` : undefined}
          testId={`browse-row-${row.id}`}
        />
      ))}
      {data && data.rows.length === 0 && (
        <p className="mt-16 text-[16px] text-[#8A8A8A]" data-testid="browse-empty">
          No {title.toLowerCase()} yet. {tag === "Festival" ? "Attach videos to a festival in Admin Settings to show them here." : `Tag videos with “${tag}” in Admin Settings to show them here.`}
        </p>
      )}
    </div>
  );
}
